export const LOCAL_STORAGE_KEYS = {
  SETTINGS: "settings",
  SEARCH_SUGGESTIONS: "searchSuggestions",
} as const;
